/**
 * The question checkout asks the server: which waivers does a family owe for
 * this class? A waiver can be scoped to a program, a school or the class
 * itself, so all three go along.
 *
 * @param {Object|null} classData - the class being bought
 * @returns {{program_id?: string, school_id?: string, class_id?: string}}
 */
export const waiverScopeFor = (classData) => ({
  program_id: classData?.program?.id || classData?.program_id,
  school_id: classData?.school?.id || classData?.school_id,
  class_id: classData?.id,
});

/**
 * How a waiver template's reach reads in the admin list. The narrowest
 * scope wins: a class waiver is named as one even if it carries others.
 *
 * @param {Object} waiver - a waiver template
 * @returns {string}
 */
export const waiverScopeLabel = (waiver) => {
  if (waiver?.applies_to_class_id) return 'Class Specific';
  if (waiver?.applies_to_program_id && waiver?.applies_to_school_id) {
    return 'Program & School Specific';
  }
  if (waiver?.applies_to_program_id) return 'Program Specific';
  if (waiver?.applies_to_school_id) return 'School Specific';
  return 'Global';
};
